import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FC } from "react";
import BreadcrumbsComponent from "../Breadcrumbs/BreadcrumbsComponent";
import { ChevronDownIcon, ChevronLeftIcon } from "@chakra-ui/icons";
import { primaryColor } from "../../../utils/colors";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutComponent from "../../atom/Logout/LogoutComponent";
import { menuItemStyles, menuListStyles } from "../../../utils/styles/styles";
import { useAtom } from "jotai";
import { authAtom } from "../../../provider/authAtom";
import { useSelector } from "react-redux";
import { IRootState } from "../../../redux/store/store";
import { BsPerson } from "react-icons/bs";
import { goBack } from "../../../helpers/goBack";

const HeaderComponent: FC = () => {
  const [auth] = useAtom(authAtom);
  const { user } = auth;
  const { pathname } = useLocation();
  const pathSegments = pathname.split("/").filter((segment) => segment !== "");
  const navigate = useNavigate();

  const shouldShowBackButton = !(
    (pathSegments[0] === "dashboard" && pathSegments.length === 1) ||
    (pathSegments[0] === "gerir" && pathSegments.length === 2)
  );

  const withConfirm = useSelector(
    (state: IRootState) => state.navigation.withConfirm,
  );

  const onClickGoBack = () => {
    if (withConfirm) {
      withConfirm(() => {});
    } else {
      goBack(navigate, pathname);
    }
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="start"
      color={primaryColor}
    >
      <Stack spacing={8}>
        <BreadcrumbsComponent />
        {shouldShowBackButton && (
          <Box mb={4}>
            <Button
              variant="tertiary"
              leftIcon={<ChevronLeftIcon boxSize={5} />}
              onClick={onClickGoBack}
            >
              <Text as="b">Voltar</Text>
            </Button>
          </Box>
        )}
      </Stack>
      <Flex display="column" gap={1}>
        <Menu placement="bottom-end">
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon boxSize={4} />}
            variant="tertiary"
          >
            {user?.name}
          </MenuButton>
          <MenuList sx={menuListStyles}>
            <VStack gap="2.5">
              <MenuItem as={Link} to="/minha-conta" sx={menuItemStyles}>
                <Flex alignItems="center">
                  <Button
                    aria-label="Minha Conta"
                    leftIcon={<BsPerson size="20px" color="black" />}
                    variant="tertiary"
                  >
                    <Text fontWeight="normal" color="black">
                      Minha Conta
                    </Text>
                  </Button>
                </Flex>
              </MenuItem>
              <MenuItem sx={menuItemStyles}>
                <LogoutComponent />
              </MenuItem>
            </VStack>
          </MenuList>
        </Menu>
        <Text fontSize="xs">{user?.role?.name}</Text>
      </Flex>
    </Flex>
  );
};

export default HeaderComponent;
